const DeliveryIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.01953 17.0762C4.25474 17.6921 4.67073 18.2224 5.21287 18.5976C5.75501 18.9728 6.39793 19.1752 7.05721 19.1783C7.71649 19.1814 8.36129 18.985 8.90693 18.6149C9.45256 18.2449 9.87351 17.7184 10.1145 17.1048L4.01953 17.0762Z"
        fill="#2D2E2F"
        stroke="#1C1D1F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.9913 11.3486L18.3859 11.7612L17.0664 12.5742V6.96533H18.3042L19.9913 11.3486Z"
        fill="#F59F00"
      />
      <path
        d="M20.4618 19.3762C22.2712 19.3762 23.738 17.9094 23.738 16.1C23.738 14.2906 22.2712 12.8237 20.4618 12.8237C18.6524 12.8237 17.1855 14.2906 17.1855 16.1C17.1855 17.9094 18.6524 19.3762 20.4618 19.3762Z"
        fill="#2D2E2F"
        stroke="#1C1D1F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8174 15.5889C15.8524 14.4881 16.3067 13.4423 17.0873 12.6655C17.868 11.8887 18.9159 11.4395 20.0169 11.4098L18.2766 6.98975H17.096"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8169 17.2108H1.59668C1.59668 13.9428 3.23072 12.4803 3.23072 12.4803V9.62073C3.23072 9.40404 3.31679 9.19623 3.47001 9.04301C3.62324 8.88979 3.83105 8.80371 4.04773 8.80371H11.119C11.3357 8.80371 11.5435 8.88979 11.6967 9.04301C11.85 9.19623 11.936 9.40404 11.936 9.62073V12.7336L14.2033 15.5727H15.8373L15.8169 17.2108Z"
        fill="#F59F00"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6328 4.62879H15.6786C15.9141 4.60774 16.1508 4.65325 16.3617 4.76014C16.5726 4.86703 16.7492 5.03101 16.8714 5.23339C17.1043 5.64189 17.0512 6.69993 17.0512 7.65993V12.5906"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9624 4.82373C20.9624 4.68457 20.9044 4.5517 20.8024 4.45708C20.7003 4.36247 20.5635 4.31466 20.4247 4.32515C19.9385 4.36194 19.4841 4.58106 19.1525 4.93865C18.8209 5.29623 18.6367 5.76587 18.6367 6.25351C18.6367 6.74115 18.8209 7.2108 19.1525 7.56838C19.4841 7.92596 19.9385 8.14509 20.4247 8.18187C20.5635 8.19237 20.7003 8.14456 20.8024 8.04994C20.9044 7.95532 20.9624 7.82246 20.9624 7.68329V4.82373Z"
        fill="#1C1D1F"
        stroke="#1C1D1F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DeliveryIcon;
